<form *ngIf="authForm && fields" [formGroup]="authForm" (submit)="submit()">
    <text-form-field *ngFor="let fieldConfig of fields" [fieldConfig]="fieldConfig" [isSubmit]="isSubmit"></text-form-field>
    <button type="submit" [title]="wording.submit">
        {{wording.submit}}
    </button>
</form>